import 'vuetify/dist/vuetify.min.css'
import 'font-awesome/css/font-awesome.css'

import Vue from 'vue'
import Vuetify from 'vuetify'
import VModal from 'vue-js-modal'
import VueMoment from 'vue-moment'
import VueRouter from 'vue-router'

import Services from '../components/services/Services'
import store from '../store/services'
import '@/plugins/commonPlugins'

Vue.use(Vuetify, {
  theme: {
    primary: '#5c9ccf',
    secondary: '#45769c',
    error: '#d53636',
    info: '#65c635',
    success: '#65c635',
    warning: '#d53636',
  },
})
Vue.use(VModal)
Vue.use(VueMoment)
Vue.use(VueRouter)

const router = new VueRouter({ mode: 'history' })

document.addEventListener('DOMContentLoaded', () => {
  const el = document.body.appendChild(document.createElement('services'))

  // eslint-disable-next-line no-unused-vars
  const app = new Vue({
    el,
    store,
    router,
    render: (h) => h(Services),
  })
})
